// REACT_APP_BRAND is inlined at build time, so only the chosen brand's copy, images and fonts are bundled.
const brand =
	process.env.REACT_APP_BRAND === "bmw"
		? require("./bmw").default
		: require("./jlr").default;

export default brand;
